<div class="cropImage">
  <img :src="cropImageSrc" />
</div>
